import React from 'react';

import classNames from 'classnames';

import { DropDownListItemProps } from '@ast/magma/components/dropdownlist/dropdownlist';
import { ListItem } from '@ast/magma/components/list';
import textItemStyles from '@ast/magma/components/list/textitem/textitem.pcss';

import { Country } from '@app/common/utils/countries';

import { FlagIcon } from '../../FlagIcon';

import styles from './CountrySelectorItem.pcss';

export const CountrySelectorItem = (item: any, props: DropDownListItemProps) => {
  const { name, countryCode, dialCode } = item as Country;

  return (
    <ListItem key={countryCode} {...props}>
      <span className={classNames(
        textItemStyles.container,
        styles.itemContainer,
      )}
      >
        <FlagIcon
          className={styles.flagIcon}
          country={countryCode}
        />
        <span>{dialCode}</span>
        <span className={styles.label}>{name}</span>
      </span>
    </ListItem>
  );
};
